"use client";
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { Icon } from '../../Icon/Icon.web.js';

var _excluded = ["color", "size"];
var IconMethane = function IconMethane(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === undefined ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    sizeProp = _ref$size === undefined ? '48px' : _ref$size,
    props = _objectWithoutProperties(_ref, _excluded);
  var size = sizeProp;
  return /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
    fill: "none",
    viewBox: "0 0 48 48",
    width: size,
    height: size
  }, /*#__PURE__*/React.createElement("path", {
    fill: color,
    fillRule: "evenodd",
    d: "m26.584 5.33-.324-.004-.35.005a12.44 12.44 0 0 0-9.883 5.415l-.009.013-.256-.19a6.83 6.83 0 0 0-4.26-1.238c-1.765-.051-3.548.642-4.87 1.923a6.84 6.84 0 0 0-2.082 4.881l.007.344c.005.114.013.228.024.351l-.272.203A11 11 0 0 0 0 25.473C.102 31.52 4.997 36.331 11 36.33h3v-2h-3l-.262-.004A9 9 0 0 1 2 25.483c.08-2.96 1.653-5.724 4.194-7.327l.578-.365-.13-.672-.041-.241a4.84 4.84 0 0 1 4.922-5.548c1.553-.072 2.982.539 3.952 1.656l.947 1.09.688-1.27.155-.277a10.46 10.46 0 0 1 9.31-5.2 10.5 10.5 0 0 1 7.545 2.993c2 1.96 3.13 4.64 3.14 7.441v1.612l1.005-.005.245.003A7.7 7.7 0 0 1 46 26.858c-.11 4.123-3.537 7.448-7.716 7.432H38v2h.28l.276-.003c5.137-.124 9.307-4.259 9.444-9.43l-.011-.275c-.264-4.828-3.973-8.664-8.658-9.158l-.078-.008-.016-.369A12.47 12.47 0 0 0 26.584 5.33M19 39h2v-5h2v5h2l-3 5zm9 0h2v-5h2v5h2l-3 5zm-4.515-18.46h-1.302v8.463h1.302v-3.58h4.14v3.58h1.302V20.54h-1.302v3.633h-4.14zm-9.895 4.232c0-2.487 1.731-4.388 4.14-4.388 1.159 0 2.226.404 2.955 1.068l-.664 1.145a3.22 3.22 0 0 0-2.278-.937c-1.589 0-2.812 1.263-2.812 3.112 0 1.848 1.223 3.111 2.812 3.111.924 0 1.705-.377 2.278-.937l.664 1.146c-.729.664-1.796 1.067-2.955 1.067-2.409 0-4.14-1.9-4.14-4.387m18.86-.504-2.196 2.95v.815h2.326v.96h.909v-.96h.603v-.8h-.603v-2.965zm.13 1.068v1.898h-1.403z",
    clipRule: "evenodd"
  })));
};

export { IconMethane, IconMethane as default };
